import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ConfigComponent } from './config.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { SitesComponent } from './sites/sites.component';
import { StatesComponent } from './states/states.component';
import { ScheduledMaintenanceGeneratorComponent } from './scheduledMaintenanceGenerator/scheduledMaintenanceGenerator.component';
import { ManageMacsComponent } from "./manageMacs/manageMacs.component";
import { ManageUsersComponent } from "./manageUsers/manageUsers.component";
import { PasswordComponent } from './password/password.component';
import { CacheComponent } from './cache/cache.component';

const configRoutes: Routes = [
  {
    path: "",
    component: ConfigComponent,
    canActivateChild: [AuthGuard],
    children: [
      { path: './', redirectTo: "sites", pathMatch: "full" },
      { path: '', redirectTo: "sites", pathMatch: "full"  },
      { path: 'sites', component: SitesComponent },
      { path: 'states', component: StatesComponent },
      { path: 'scheduledMaintenanceGenerator', component: ScheduledMaintenanceGeneratorComponent },
      { path: 'manageMacs', component: ManageMacsComponent },
      { path: 'manageUsers', component: ManageUsersComponent },
      { path: 'password', component: PasswordComponent },
      { path: 'cache', component: CacheComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(configRoutes)],
  exports: [RouterModule]
})
export class ConfigRoutingModule { }
